import React, { ReactNode } from 'react';
import { styles } from './ArticleBlock.css';
import { ContentCardTag, ContentCardTagProps } from '@jbhi-fi/components/src/ContentCard';
import { UserProfile, UserProfileProps } from '@jbhi-fi/components/src/UserProfile/UserProfile';
import { LoadingSkeleton } from '@jbhi-fi/components/src/LoadingSkeleton/LoadingSkeleton';
import { ContentBlock } from '@jbhi-fi/components/src/ContentBlock';

export type ArticleBlockProps = {
  tag?: ContentCardTagProps;
  date: string;
  heading: string;
  intro: string;
  content: ReactNode;
  creatorProfile: UserProfileProps | null;
  isLoading?: boolean;
};

export const ArticleBlock = ({
  tag,
  date,
  heading,
  intro,
  content,
  creatorProfile,
  isLoading = true,
}: ArticleBlockProps): JSX.Element => {
  return (
    <>
      {!isLoading && tag ? (
        <ContentBlock paddingTop={0}>
          <div className={styles.tag}>
            <ContentCardTag {...tag} />
          </div>
        </ContentBlock>
      ) : null}
      <ContentBlock paddingTop={{ mobile: 8, tablet: 10 }}>
        <div className={styles.date}>{date}</div>
      </ContentBlock>
      <ContentBlock paddingTop={2.5}>
        <h1 className={styles.heading}>{heading}</h1>
      </ContentBlock>
      <ContentBlock paddingTop={5}>
        {isLoading || !creatorProfile ? (
          <LoadingSkeleton.Box height="35px" width="300px" />
        ) : (
          <UserProfile {...creatorProfile} />
        )}
      </ContentBlock>
      <ContentBlock paddingTop={intro ? 10 : 7.5} paddingBottom={4}>
        <p className={styles.intro}>{intro}</p>
      </ContentBlock>
      {content}
    </>
  );
};
